import api from 'services/api';

export async function revokeInvitation(id: string) {
  return api.put(`api/dashboard/invitations/${id}/revoke`);
}
